"use strict";

exports.__esModule = true;
exports.MAX_SEARCH_ELEMENTS = exports.DsPagination = void 0;

require("./DsPagination.css");

var _components = require("@sg-bootstrap/components/dist/react-library/src/components");

var _jsxRuntime = require("react/jsx-runtime");

// @ts-nocheck
var MAX_SEARCH_ELEMENTS = 10000;
exports.MAX_SEARCH_ELEMENTS = MAX_SEARCH_ELEMENTS;

var DsPagination = function DsPagination(_ref) {
  var nbElements = _ref.nbElements,
      nbTotalElements = _ref.nbTotalElements,
      nbElementsByPage = _ref.nbElementsByPage,
      activePage = _ref.activePage,
      onPageClick = _ref.onPageClick,
      _ref$hasMax = _ref.hasMax,
      hasMax = _ref$hasMax === void 0 ? false : _ref$hasMax,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-EN' : _ref$locale,
      _ref$labelPageSize = _ref.labelPageSize,
      labelPageSize = _ref$labelPageSize === void 0 ? 'Showing' : _ref$labelPageSize,
      _ref$labelTotal = _ref.labelTotal,
      labelTotal = _ref$labelTotal === void 0 ? 'of' : _ref$labelTotal,
      _ref$displayLabel = _ref.displayLabel,
      displayLabel = _ref$displayLabel === void 0 ? true : _ref$displayLabel;
  var numberFormat = new Intl.NumberFormat(locale);
  var currentNbElements = hasMax && nbTotalElements > MAX_SEARCH_ELEMENTS ? MAX_SEARCH_ELEMENTS : nbTotalElements;
  var nbPages = currentNbElements % nbElementsByPage === 0 ? currentNbElements / nbElementsByPage : Math.floor(currentNbElements / nbElementsByPage + 1);

  var handlePageSelected = function handlePageSelected(event) {
    onPageClick(event.detail);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: 'd-flex justify-content-end align-items-center my-2',
    children: [displayLabel ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: 'mb-0 me-3',
      children: [labelPageSize, "\xA0", numberFormat.format(nbElements), "\xA0", labelTotal, "\xA0", numberFormat.format(currentNbElements)]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SgPagination, {
      pages: nbPages,
      active: activePage,
      visiblePageNumber: 5,
      onPageSelected: handlePageSelected
    }, null)]
  });
};

exports.DsPagination = DsPagination;